// Mock data de vehículos — marcas, modelos y ciudades de Colombia
import { VehicleApiResponse } from '../../app/features/quoter/models/vehicle.model';

export const MOCK_VEHICLES_BY_PLATE: Record<string, VehicleApiResponse> = {
  ABCD12: {
    Ppu: 'ABCD12',
    DvPpu: '',
    Nombre: null,
    AnioFabricacion: '2023',
    Marca: 'Toyota',
    Modelo: 'Corolla',
    Color: '',
    TipoVehiculo: '',
    NumeroMotor: 'T1234567890',
    UltimaTransferencia: '',
    NumeroChasis: '9BRTK12J438001234',
    Tasacion: '',
    descripcion: '',
    codigo: 'TOY',
  },
  XYWZ34: {
    Ppu: 'XYWZ34',
    DvPpu: '',
    Nombre: null,
    AnioFabricacion: '2021',
    Marca: 'Suzuki',
    Modelo: 'Swift',
    Color: '',
    TipoVehiculo: '',
    NumeroMotor: 'K12MN456789',
    UltimaTransferencia: '',
    NumeroChasis: 'JS3YC415S00123456',
    Tasacion: '',
    descripcion: '',
    codigo: 'SUZ',
  },
  KZLX23: {
    Ppu: 'KZLX23',
    DvPpu: '',
    Nombre: null,
    AnioFabricacion: '2026',
    Marca: 'Chevrolet',
    Modelo: 'Tracker',
    Color: '',
    TipoVehiculo: '',
    NumeroMotor: 'G4LAJP085024',
    UltimaTransferencia: '',
    NumeroChasis: '9BGED76C8TV15695884',
    Tasacion: '',
    descripcion: '',
    codigo: 'CHV',
  },
};

export const MOCK_VEHICLE_BRANDS = [
  {
    id: 'chevrolet',
    name: 'Chevrolet',
    brand: 'Chevrolet',
    brandSol: 'CHV',
    models: [
      { id: 'spark', name: 'Spark', brandId: 'chevrolet' },
      { id: 'onix', name: 'Onix', brandId: 'chevrolet' },
      { id: 'tracker', name: 'Tracker', brandId: 'chevrolet' },
      { id: 'equinox', name: 'Equinox', brandId: 'chevrolet' },
      { id: 'colorado', name: 'Colorado', brandId: 'chevrolet' },
    ],
  },
  {
    id: 'toyota',
    name: 'Toyota',
    brand: 'Toyota',
    brandSol: 'TOY',
    models: [
      { id: 'corolla', name: 'Corolla', brandId: 'toyota' },
      { id: 'hilux', name: 'Hilux', brandId: 'toyota' },
      { id: 'rav4', name: 'RAV4', brandId: 'toyota' },
      { id: 'yaris', name: 'Yaris', brandId: 'toyota' },
      { id: 'fortuner', name: 'Fortuner', brandId: 'toyota' },
    ],
  },
  {
    id: 'renault',
    name: 'Renault',
    brand: 'Renault',
    brandSol: 'REN',
    models: [
      { id: 'logan', name: 'Logan', brandId: 'renault' },
      { id: 'sandero', name: 'Sandero', brandId: 'renault' },
      { id: 'duster', name: 'Duster', brandId: 'renault' },
      { id: 'kwid', name: 'Kwid', brandId: 'renault' },
      { id: 'stepway', name: 'Stepway', brandId: 'renault' },
    ],
  },
  {
    id: 'mazda',
    name: 'Mazda',
    brand: 'Mazda',
    brandSol: 'MAZ',
    models: [
      { id: 'mazda2', name: 'Mazda2', brandId: 'mazda' },
      { id: 'mazda3', name: 'Mazda3', brandId: 'mazda' },
      { id: 'cx3', name: 'CX-3', brandId: 'mazda' },
      { id: 'cx5', name: 'CX-5', brandId: 'mazda' },
      { id: 'bt50', name: 'BT-50', brandId: 'mazda' },
    ],
  },
  {
    id: 'kia',
    name: 'KIA',
    brand: 'KIA MOTORS',
    brandSol: 'KIA',
    models: [
      { id: 'picanto', name: 'Picanto', brandId: 'kia' },
      { id: 'rio', name: 'Rio', brandId: 'kia' },
      { id: 'sportage', name: 'Sportage', brandId: 'kia' },
      { id: 'sorento', name: 'Sorento', brandId: 'kia' },
      { id: 'seltos', name: 'Seltos', brandId: 'kia' },
    ],
  },
  {
    id: 'hyundai',
    name: 'Hyundai',
    brand: 'Hyundai',
    brandSol: 'HYU',
    models: [
      { id: 'tucson', name: 'Tucson', brandId: 'hyundai' },
      { id: 'elantra', name: 'Elantra', brandId: 'hyundai' },
      { id: 'accent', name: 'Accent', brandId: 'hyundai' },
      { id: 'creta', name: 'Creta', brandId: 'hyundai' },
      { id: 'santa-fe', name: 'Santa Fe', brandId: 'hyundai' },
    ],
  },
  {
    id: 'volkswagen',
    name: 'Volkswagen',
    brand: 'Volkswagen',
    brandSol: 'VOL',
    models: [
      { id: 'polo', name: 'Polo', brandId: 'volkswagen' },
      { id: 'golf', name: 'Golf', brandId: 'volkswagen' },
      { id: 'tiguan', name: 'Tiguan', brandId: 'volkswagen' },
      { id: 'jetta', name: 'Jetta', brandId: 'volkswagen' },
      { id: 'amarok', name: 'Amarok', brandId: 'volkswagen' },
    ],
  },
  {
    id: 'ford',
    name: 'Ford',
    brand: 'Ford',
    brandSol: 'FRD',
    models: [
      { id: 'fiesta', name: 'Fiesta', brandId: 'ford' },
      { id: 'focus', name: 'Focus', brandId: 'ford' },
      { id: 'escape', name: 'Escape', brandId: 'ford' },
      { id: 'ranger', name: 'Ranger', brandId: 'ford' },
      { id: 'explorer', name: 'Explorer', brandId: 'ford' },
    ],
  },
  {
    id: 'nissan',
    name: 'Nissan',
    brand: 'Nissan',
    brandSol: 'NIS',
    models: [
      { id: 'versa', name: 'Versa', brandId: 'nissan' },
      { id: 'sentra', name: 'Sentra', brandId: 'nissan' },
      { id: 'kicks', name: 'Kicks', brandId: 'nissan' },
      { id: 'qashqai', name: 'Qashqai', brandId: 'nissan' },
      { id: 'navara', name: 'Navara', brandId: 'nissan' },
    ],
  },
  {
    id: 'suzuki',
    name: 'Suzuki',
    brand: 'Suzuki',
    brandSol: 'SUZ',
    models: [
      { id: 'alto', name: 'Alto', brandId: 'suzuki' },
      { id: 'swift', name: 'Swift', brandId: 'suzuki' },
      { id: 'vitara', name: 'Vitara', brandId: 'suzuki' },
      { id: 'grand-vitara', name: 'Grand Vitara', brandId: 'suzuki' },
      { id: 'jimny', name: 'Jimny', brandId: 'suzuki' },
    ],
  },
];

export const MOCK_VEHICLE_YEARS: number[] = Array.from(
  { length: 12 },
  (_, i) => 2026 - i,
);

export const MOCK_REGIONS = [
  { id: 'arica', name: 'Región de Arica y Parinacota' },
  { id: 'tarapaca', name: 'Región de Tarapacá' },
  { id: 'antofagasta', name: 'Región de Antofagasta' },
  { id: 'atacama', name: 'Región de Atacama' },
  { id: 'coquimbo', name: 'Región de Coquimbo' },
  { id: 'valparaiso', name: 'Región de Valparaíso' },
  { id: 'rm', name: 'Región Metropolitana' },
  { id: 'ohiggins', name: "Región del Libertador Gral. B. O'Higgins" },
  { id: 'maule', name: 'Región del Maule' },
  { id: 'nuble', name: 'Región de Ñuble' },
  { id: 'biobio', name: 'Región del Biobío' },
  { id: 'araucania', name: 'Región de La Araucanía' },
  { id: 'los-rios', name: 'Región de Los Ríos' },
  { id: 'los-lagos', name: 'Región de Los Lagos' },
  { id: 'aysen', name: 'Región de Aysén' },
  { id: 'magallanes', name: 'Región de Magallanes y Antártica' },
];

export const MOCK_COMMUNES_BY_REGION: Record<string, { id: string; name: string }[]> = {
  arica: [
    { id: 'arica', name: 'Arica' },
    { id: 'camarones', name: 'Camarones' },
    { id: 'general-lagos', name: 'General Lagos' },
    { id: 'putre', name: 'Putre' },
  ],
  tarapaca: [
    { id: 'iquique', name: 'Iquique' },
    { id: 'alto-hospicio', name: 'Alto Hospicio' },
    { id: 'pica', name: 'Pica' },
    { id: 'pozo-almonte', name: 'Pozo Almonte' },
  ],
  antofagasta: [
    { id: 'antofagasta', name: 'Antofagasta' },
    { id: 'calama', name: 'Calama' },
    { id: 'mejillones', name: 'Mejillones' },
    { id: 'tocopilla', name: 'Tocopilla' },
  ],
  atacama: [
    { id: 'copiapo', name: 'Copiapó' },
    { id: 'vallenar', name: 'Vallenar' },
    { id: 'chanaral', name: 'Chañaral' },
  ],
  coquimbo: [
    { id: 'la-serena', name: 'La Serena' },
    { id: 'coquimbo', name: 'Coquimbo' },
    { id: 'ovalle', name: 'Ovalle' },
    { id: 'illapel', name: 'Illapel' },
  ],
  valparaiso: [
    { id: 'valparaiso', name: 'Valparaíso' },
    { id: 'vina-del-mar', name: 'Viña del Mar' },
    { id: 'quilpue', name: 'Quilpué' },
    { id: 'villa-alemana', name: 'Villa Alemana' },
    { id: 'concon', name: 'Concón' },
    { id: 'san-antonio', name: 'San Antonio' },
  ],
  rm: [
    { id: 'santiago', name: 'Santiago' },
    { id: 'providencia', name: 'Providencia' },
    { id: 'las-condes', name: 'Las Condes' },
    { id: 'nunoa', name: 'Ñuñoa' },
    { id: 'vitacura', name: 'Vitacura' },
    { id: 'lo-barnechea', name: 'Lo Barnechea' },
    { id: 'maipu', name: 'Maipú' },
    { id: 'pudahuel', name: 'Pudahuel' },
    { id: 'la-florida', name: 'La Florida' },
    { id: 'penalolen', name: 'Peñalolén' },
    { id: 'la-reina', name: 'La Reina' },
    { id: 'macul', name: 'Macul' },
    { id: 'san-miguel', name: 'San Miguel' },
    { id: 'estacion-central', name: 'Estación Central' },
    { id: 'quilicura', name: 'Quilicura' },
    { id: 'huechuraba', name: 'Huechuraba' },
    { id: 'recoleta', name: 'Recoleta' },
    { id: 'independencia', name: 'Independencia' },
    { id: 'cerro-navia', name: 'Cerro Navia' },
    { id: 'conchali', name: 'Conchalí' },
  ],
  ohiggins: [
    { id: 'rancagua', name: 'Rancagua' },
    { id: 'san-fernando', name: 'San Fernando' },
    { id: 'rengo', name: 'Rengo' },
  ],
  maule: [
    { id: 'talca', name: 'Talca' },
    { id: 'curico', name: 'Curicó' },
    { id: 'linares', name: 'Linares' },
    { id: 'cauquenes', name: 'Cauquenes' },
  ],
  nuble: [
    { id: 'chillan', name: 'Chillán' },
    { id: 'chillan-viejo', name: 'Chillán Viejo' },
    { id: 'san-carlos', name: 'San Carlos' },
  ],
  biobio: [
    { id: 'concepcion', name: 'Concepción' },
    { id: 'talcahuano', name: 'Talcahuano' },
    { id: 'chiguayante', name: 'Chiguayante' },
    { id: 'los-angeles', name: 'Los Ángeles' },
    { id: 'hualpen', name: 'Hualpén' },
  ],
  araucania: [
    { id: 'temuco', name: 'Temuco' },
    { id: 'padre-las-casas', name: 'Padre Las Casas' },
    { id: 'angol', name: 'Angol' },
    { id: 'villarrica', name: 'Villarrica' },
  ],
  'los-rios': [
    { id: 'valdivia', name: 'Valdivia' },
    { id: 'la-union', name: 'La Unión' },
    { id: 'panguipulli', name: 'Panguipulli' },
  ],
  'los-lagos': [
    { id: 'puerto-montt', name: 'Puerto Montt' },
    { id: 'osorno', name: 'Osorno' },
    { id: 'castro', name: 'Castro' },
    { id: 'ancud', name: 'Ancud' },
  ],
  aysen: [
    { id: 'coyhaique', name: 'Coyhaique' },
    { id: 'aisen', name: 'Aisén' },
    { id: 'cisnes', name: 'Cisnes' },
  ],
  magallanes: [
    { id: 'punta-arenas', name: 'Punta Arenas' },
    { id: 'puerto-natales', name: 'Puerto Natales' },
    { id: 'porvenir', name: 'Porvenir' },
  ],
};

export const MOCK_CITIES = [
  { id: 'bogota', name: 'Bogotá D.C.', region: 'Cundinamarca' },
  { id: 'medellin', name: 'Medellín', region: 'Antioquia' },
  { id: 'cali', name: 'Cali', region: 'Valle del Cauca' },
  { id: 'barranquilla', name: 'Barranquilla', region: 'Atlántico' },
  { id: 'cartagena', name: 'Cartagena', region: 'Bolívar' },
  { id: 'cucuta', name: 'Cúcuta', region: 'Norte de Santander' },
  { id: 'bucaramanga', name: 'Bucaramanga', region: 'Santander' },
  { id: 'ibague', name: 'Ibagué', region: 'Tolima' },
  { id: 'pereira', name: 'Pereira', region: 'Risaralda' },
  { id: 'manizales', name: 'Manizales', region: 'Caldas' },
  { id: 'pasto', name: 'Pasto', region: 'Nariño' },
  { id: 'neiva', name: 'Neiva', region: 'Huila' },
  { id: 'villavicencio', name: 'Villavicencio', region: 'Meta' },
  { id: 'armenia', name: 'Armenia', region: 'Quindío' },
  { id: 'monteria', name: 'Montería', region: 'Córdoba' },
];
